import React, { Component } from "react";
import {
  DataGrid,
  FilterRow,
  Editing,
  Column,
  Paging,
  Pager,
  FormItem,
  Lookup,
  StateStoring,
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import {
  criarPrecoPublicoDs,
  criarContribuinteDs,
  criarPermissionariosDs,
} from "../../DataSources";
import Memoria from "../../Memoria";

const localStorageKey = "cadastroPermissionariosGridState";

export default class PermissionarioBox extends Component {
  constructor() {
    super();
    this._gridInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("permissionarios/editar/" + e.data.id);
  }

  componentDidMount() { 
    Memoria.redirecionarSeNecessario(this.props.location, this.props.history);
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <PaginaToolbar
            titulo="Permissionários"
            novoCb={this.novoRegistro.bind(this)}
          >
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={criarPermissionariosDs()}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              focusedRowEnabled={true}
              wordWrapEnabled={window.innerWidth < 800}
              filterSyncEnabled={true}
              onEditingStart={this.onAtualizandoRow}
            >
              <StateStoring
                enabled={true}
                type={"localStorage"}
                storageKey={localStorageKey}
              />
              <FilterRow visible={true} />
              <Editing allowDeleting={true} allowUpdating={true} useIcons={true} />
              <Column
                dataField={"sequencial"}
                caption={"#"}
                allowEditing={false}
                width={80}
                alignment={"center"}
              />
              <Column
                dataField={"prefeituraId"}
                caption={"Prefeitura"}
                visible={false}
              >
                <FormItem visible={false}></FormItem>
              </Column>
              <Column dataField={"contribuinte.nome"} caption={"Contribuinte"} />
              
              <Column dataField={"precoPublicoId"} caption={"Preço Público"}>
                <Lookup
                  dataSource={criarPrecoPublicoDs()}
                  valueExpr={"id"}
                  displayExpr={"descricao"}
                />
              </Column>
              <Column
                dataField={"baseCalculo"}
                caption={"Base de Cálculo"}
                format={{ type: "fixedPoint", precision: 2 }}
              />
              <Column dataField={"lojaBox"} caption={"Loja Box"} />
              <Column dataField={"galpao"} caption={"Galpão"} />

              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }

  novoRegistro() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("permissionarios/novo");
  }
}
